export const setKey = (str)=>{
  let timestamp = new Date().valueOf();
  return str + "-" + timestamp;
}